/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Filter } from './../../shared/models/filter.model';
import { SortOrder } from './../../shared/models/sort-order.model';

export interface IListRequestModel {
  paged: boolean,
  pageNumber: number,
  pageSize: number,
  includeUnfilteredTotalCount: boolean,
  sort: Array<SortOrder>,
  filters: Array<Filter>
}

export interface INoteListRequestModel extends IListRequestModel {
softwareFeatureId: number,
}

export class ListRequestModelNoFilter  {
  constructor(
    public paged: boolean = true,
    public pageNumber: number = 1,
    public pageSize: number = 20,
    public sort: Array<SortOrder> = []) {
  }

}


export class ListRequestModel extends ListRequestModelNoFilter implements IListRequestModel {
  constructor(
    public paged: boolean = true,
    public pageNumber: number = 1,
    public pageSize: number = 20,
    public sort: Array<SortOrder> = [],
    public filters: Array<Filter> = [],
    public includeUnfilteredTotalCount: boolean = false) {
      super(paged, pageNumber, pageSize, sort);
    }

  getFilterByName(fieldName: string): Filter {
    return this.filters.find(f => f.field == fieldName);
  }
}


export class ListStorageModel extends ListRequestModelNoFilter {
  constructor(
    public paged: boolean = true,
    public pageNumber: number = 1,
    public pageSize: number = 20,
    public sort: Array<SortOrder> = [],
    public groupBy: string) {
      super(paged, pageNumber, pageSize, sort);
    }

}

